// extracted by mini-css-extract-plugin
export default {"popular":"HeadToHeadCardPlaceholder_popular__aj-Lj","container":"HeadToHeadCardPlaceholder_container__yO1Jf","wrapper":"HeadToHeadCardPlaceholder_wrapper__4ZcB9"};